module.exports = __webpack_public_path__ + "static/img/500.990ae4d0.svg";